import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { UwTranslationService } from '@uw/core/services/uw-translation-service.service';
import { BehaviorSubject, merge, Observable, of, Subject, startWith, switchMap, tap } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class SubHeaderService {

  private readonly _titleLocalizationKeySubject: Subject<string | null> = new Subject();
  private readonly _subTitleLocalizationKeySubject: Subject<string | null> = new Subject();
  private readonly _titleSubject: BehaviorSubject<string | null> = new BehaviorSubject("" as string | null);
  private readonly _subTitleSubject: BehaviorSubject<string | null> = new BehaviorSubject("" as string | null);
  private readonly _badgeSubject: BehaviorSubject<string | null> = new BehaviorSubject<string | null>(null);

  readonly subTitle$: Observable<string> = merge(this._subTitleSubject, this._subTitleLocalizationKeySubject
    .pipe(
      switchMap(localizationKey => localizationKey ? this._translateService.get(localizationKey) : of(null)),
    ))

  readonly title$: Observable<string> = merge(this._titleSubject, this._titleLocalizationKeySubject
    .pipe(
      switchMap(localizationKey => localizationKey ? this._translateService.get(localizationKey) : of(null)),
    ));

  readonly badge$: Observable<string | null> = this._badgeSubject.asObservable();

  constructor(
    private readonly _translateService: TranslateService,
    private readonly _uwTranslateService: UwTranslationService
  ) {

  }

  setTitle(title: string | null) {
    queueMicrotask(() => this._titleSubject.next(title));
  }

  /**
   *
   * @deprecated Since 6.3 Release. Use setSubTitleWithTranslateParams() instead.
   */
  setSubTitle(title: string | null) {
    queueMicrotask(() => this._subTitleSubject.next(title));
  }

  setSubTitleWithTranslateParams(subTitleTranslationKey: string, translationParams?: {[key: string]: string}) {
    const subTitle = this._uwTranslateService.translateWithParams(subTitleTranslationKey, translationParams);
    queueMicrotask(() => this._subTitleSubject.next(subTitle));
  }

  setBadge(badge: string | null) {
    queueMicrotask(() => this._badgeSubject.next(badge));
  }

  setTitleByLocalizationKey(localizationKey: string | null) {
    queueMicrotask(() => this._titleLocalizationKeySubject.next(localizationKey));
  }

  setSubTitleByLocalizationKey(localizationKey: string | null) {
    queueMicrotask(() => this._subTitleLocalizationKeySubject.next(localizationKey));
  }
}
